import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

/**
 * Compare-plans CTA dialog — shown when a free user clicks a paid-only
 * control. Title + body use translation keys derived from `feature`:
 *
 *   feature="LEAGUES"      → body key "LOCKED_LEAGUES_BODY"
 *   feature="PRINT_TICKETS" → body key "LOCKED_PRINT_TICKETS_BODY"
 *
 * Declarative: the consumer owns the `open` flag and embeds this in its
 * own template. Built on `<bv-dialog>` so the surface chrome comes from
 * the design system — no MatDialog, no nested containers.
 *
 *   <app-locked-feature-dialog
 *     feature="PRINT_TICKETS"
 *     tier="PRO"
 *     [open]="lockedDialogOpen"
 *     (closed)="lockedDialogOpen = false"
 *   ></app-locked-feature-dialog>
 */
@Component({
    selector: "app-locked-feature-dialog",
    templateUrl: "./locked-feature-dialog.component.html",
    imports: [BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent, BvButtonComponent, TranslateModule]
})
export class LockedFeatureDialogComponent {
  /** Short feature key, e.g. "LEAGUES", "PRINT_TICKETS". Drives body copy. */
  @Input() feature!: string;
  /** Translation key for the required tier, e.g. "PRO", "CLUB", "HOME_GAME". */
  @Input() tier!: string;
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  constructor(private router: Router) {}

  get bodyKey(): string {
    return `LOCKED_${this.feature}_BODY`;
  }

  get titleKey(): string {
    return "LOCKED_FEATURE_TITLE";
  }

  goToCompare(): void {
    this.closed.emit();
    this.router.navigate(["/subscription"], {
      queryParams: { source: `lock_${this.feature.toLowerCase()}` },
    });
  }

  dismiss(): void {
    this.closed.emit();
  }
}
